import { render } from "./PaisSelect.vue?vue&type=template&id=544e6fd6&scoped=true"
import script from "./PaisSelect.vue?vue&type=script&lang=js"
export * from "./PaisSelect.vue?vue&type=script&lang=js"

import "./PaisSelect.vue?vue&type=style&index=0&id=544e6fd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544e6fd6"]])

export default __exports__